import { render, staticRenderFns } from "./SendSwitchCard.vue?vue&type=template&id=2e5b40dd&scoped=true"
import script from "./SendSwitchCard.vue?vue&type=script&lang=js"
export * from "./SendSwitchCard.vue?vue&type=script&lang=js"
import style0 from "./SendSwitchCard.vue?vue&type=style&index=0&id=2e5b40dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5b40dd",
  null
  
)

export default component.exports